const addOnsTypes = {
    BOOKING_ONLY: 1,
    CONFIRMATION_PAGE_ONLY: 2,
    BOOKING_AND_CONFIRMATION_PAGE: 3
};

const addOnsCrossSellConfigItems = [
    {
        code: 'showAddOnCrossSellInProductDetails',
        title: "Product Details (applies when retailing is enabled)"
    },
    {
        code: 'showAddOnCrossSellInAddedToCartOverlay',
        title: 'Added to Cart overlay'
    },
    {
        code: 'showAddOnCrossSellOnCartPage',
        title: 'Shopping Cart page'
    },
    {
        code: 'showAddOnCrossSellOnConfirmationPage',
        title: 'Confirmation page'
    }
];

const travelAgencyDisplayNameOptions = [
    { key: 'displayTravelAgencyCompanyName', label: 'Display Travel Agency Company Name' },
    { key: 'displayTravelAgencyBusinessName', label: 'Display Travel Agency Business Name (DBA)' }
]

export { addOnsTypes, addOnsCrossSellConfigItems, travelAgencyDisplayNameOptions };



// WEBPACK FOOTER //
// ./src/constants/GeneralConfiguration.js